import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <main className="container" style={{ padding: '4rem 1.5rem', maxWidth: '48rem' }}>
      <Helmet defer={false}>
        <title>Page not found | OriginSelect</title>
        <meta name="robots" content="noindex,follow" />
        <meta name="googlebot" content="noindex,follow" />
      </Helmet>
      <p>404</p>
      <h1>Page not found</h1>
      <p>We couldn’t find the page at this address. You can continue browsing below.</p>
      <nav aria-label="Continue browsing">
        <p><Link to="/global/home">Browse global products and guides</Link></p>
        <p><Link to="/country/canada">Browse Canadian products and guides</Link></p>
      </nav>
    </main>
  );
}
